
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Edit, Trash2, Eye, Globe } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface SitePagesProps {
  searchQuery: string;
}

const SitePages = ({ searchQuery }: SitePagesProps) => {
  // Mock data - would typically come from an API
  const pages = [
    { id: 1, title: 'Home', path: '/', status: 'published', lastUpdated: '2023-12-10', updatedBy: 'Admin User' },
    { id: 2, title: 'About Us', path: '/about', status: 'published', lastUpdated: '2023-11-05', updatedBy: 'Editor User' },
    { id: 3, title: 'Services', path: '/services', status: 'published', lastUpdated: '2023-10-22', updatedBy: 'Admin User' },
    { id: 4, title: 'Product Strategy', path: '/services/product-strategy', status: 'published', lastUpdated: '2023-09-15', updatedBy: 'Editor User' },
    { id: 5, title: 'Contact', path: '/contact', status: 'published', lastUpdated: '2023-12-01', updatedBy: 'Admin User' },
    { id: 6, title: 'Privacy Policy', path: '/privacy', status: 'draft', lastUpdated: '2023-12-05', updatedBy: 'Editor User' },
  ];
  
  const filteredPages = searchQuery 
    ? pages.filter(page => 
        page.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        page.path.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : pages;
  
  return (
    <Card>
      <div className="p-4">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Title</TableHead>
              <TableHead>Path</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Last Updated</TableHead>
              <TableHead>Updated By</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredPages.length > 0 ? (
              filteredPages.map((page) => (
                <TableRow key={page.id}>
                  <TableCell className="font-medium">{page.title}</TableCell>
                  <TableCell className="font-mono text-xs">{page.path}</TableCell>
                  <TableCell>
                    <Badge variant={page.status === 'published' ? 'default' : 'outline'}>
                      {page.status}
                    </Badge>
                  </TableCell>
                  <TableCell>{page.lastUpdated}</TableCell>
                  <TableCell>{page.updatedBy}</TableCell>
                  <TableCell className="text-right">
                    <div className="flex justify-end gap-2">
                      <Button variant="ghost" size="icon">
                        <Eye className="h-4 w-4" />
                      </Button>
                      <Button variant="ghost" size="icon">
                        <Edit className="h-4 w-4" />
                      </Button>
                      <Button variant="ghost" size="icon">
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} className="text-center py-6">
                  No pages found matching your search criteria
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};

export default SitePages;
